"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapActuatorsAndDevices = exports.convertPlugDeviceId = void 0;
const IndexApiProfileRequestTypes_1 = require("../../Types/IndexApiProfileRequestTypes");
const IndexProfile_1 = require("../../Types/IndexProfile");
const Simples_1 = require("./Simples");
const Switches_1 = require("./Switches");
const convertPlugDeviceId = (deviceId) => `${Switches_1.PLUG_SWITCH_ID_MODIFIER}${deviceId}`;
exports.convertPlugDeviceId = convertPlugDeviceId;
const mapActuatorsAndDevices = (loadActuators, loadDevices, things) => {
    const loads = [];
    const thingIds = things.map((t) => t.deviceId);
    for (const actuator of loadActuators) {
        const actuatorDevice = loadDevices.find((d) => d.id === actuator.deviceId);
        if (typeof actuatorDevice !== "undefined") {
            const realActuatorDevice = actuatorDevice;
            const isPlug = realActuatorDevice.type === IndexApiProfileRequestTypes_1.IndexAPIDeviceType.PLUG;
            const plugSwitchId = (0, exports.convertPlugDeviceId)(realActuatorDevice.id);
            const deviceIds = isPlug ? [plugSwitchId] : Object.keys(realActuatorDevice.model.deviceIds);
            const primaryThing = things.find((t) => t.deviceId === realActuatorDevice.model.primaryDeviceId);
            let checkinFwExists = false;
            let primaryFwVersion;
            if (primaryThing !== undefined) {
                const { lastCheckin, model } = primaryThing;
                checkinFwExists = lastCheckin.firmwareRevision !== undefined
                    && lastCheckin.firmwareRevision !== IndexProfile_1.UNKNOWN;
                primaryFwVersion = checkinFwExists ? lastCheckin.firmwareRevision : model.firmwareRevision;
            }
            const primarySerialNumber = (primaryThing === null || primaryThing === void 0 ? void 0 : primaryThing.model.serialNumber) || IndexProfile_1.UNKNOWN;
            const serialNumbers = isPlug
                ? [primarySerialNumber]
                : deviceIds.map((d) => { var _a; return ((_a = things.find((t) => t.deviceId === d)) === null || _a === void 0 ? void 0 : _a.model.serialNumber) || IndexProfile_1.UNKNOWN; });
            loads.push(Object.assign(Object.assign({}, actuator), { name: actuatorDevice.name, primary_mesh_id: actuatorDevice.mesh.addressId, primary_device_id: isPlug ? plugSwitchId : realActuatorDevice.model.primaryDeviceId, timer: realActuatorDevice.maxOnSeconds, kebabEnabled: realActuatorDevice.model && realActuatorDevice.model.showKebab, switches: deviceIds, isGen2: isPlug
                    || deviceIds.some((dId) => thingIds.indexOf(dId) > -1), sceneLocations: {}, primaryFwVersion, warrantyExp: (primaryThing === null || primaryThing === void 0 ? void 0 : primaryThing.warrantyExp) || null, provisioner: (primaryThing === null || primaryThing === void 0 ? void 0 : primaryThing.provisioner) ? (0, Simples_1.mapWarrantyRole)(primaryThing.provisioner) : null, primarySerialNumber,
                serialNumbers }));
        }
    }
    return loads;
};
exports.mapActuatorsAndDevices = mapActuatorsAndDevices;
//# sourceMappingURL=Loads.js.map